@if (user?.roleLevel === 95) {
<h3 class="mt-3">{{ "NAV_DASHBOARD" | translate }}</h3>

<div class="row landing-dashboard-row">
  <div class="col-md-12 mb-3 landing-dashboard-left-col">
    <div class="landing-dashboard-column landing-dashboard-column--auto mb-3">
      <div class="card-header">
        {{ "DEVICE_STATUS" | translate }}
      </div>
      <div class="card-body">
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [type]="'Online'" [class]="'statusOnline'" [data]="onlineStatus?.online" [title]="'Online' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [type]="'OfflineUnder24h'" [class]="'statusOfflineUnder'" [data]="onlineStatus?.offlineUnder24h" [title]="'OfflineUnder24h' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [type]="'OfflineOver24h'" [class]="'statusOfflineOver'" [data]="onlineStatus?.offlineOver24h" [title]="'OfflineOver24h' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [type]="'LowBattery'" [class]="'statusLowBattery'" [data]="onlineStatus?.lowBattery" [title]="'BATTERY_STATUS_WARNING' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [type]="'Excluded'" [class]="'statusExcluded'" [data]="onlineStatus?.excluded" [title]="'EXCLUDED_DEVICES' | translate" (onDeviceRemoved)="refreshOnlineStatus()"></devicestatus>
      </div>
    </div>
    <div class="mb-3">
      <app-active-alerts [showCustomer]="true"></app-active-alerts>
    </div>

    <div class="landing-dashboard-column landing-dashboard-column--auto">
      <div class="card-header">
        {{ "NEWS" | translate }}
      </div>
      <div class="card-body">
        @if (notifications.length > 0) {
          @for (notification of notifications; track notification) {
            <div>
              <div [ngClass]="notification.highlight ? 'notification-highlight' : ''">
                <strong>{{ notification.subject }}</strong><br />
                <small class="text-muted">{{ notification.timestamp | moment : "l LTS" }}</small>
                <p [innerHTML]="notification.message"></p>
              </div>
              <hr />
            </div>
          }
        }
      </div>
    </div>
  </div>
  <div class="col-md-12 mb-3 landing-dashboard-right-col">
    <div class="landing-dashboard-column">
      <div class="card-header">
        {{ "MOVE_TO" | translate }}
      </div>
      <div class="card-body p-0">
        @if (locationsLoaded) {
          @if (locations.length > 0) {
            <ul class="locations-list">
              @for (loc of locations; track loc.companyId) {
                <li class="location-item">
                  <strong>{{ loc.company }}</strong>
                  <span class="location-id">{{ loc.companyId }}</span>
                  <span class="location-address">{{ loc.address }}</span>
                </li>
              }
            </ul>
          } @else {
            <p class="p-3 text-muted">{{ "NO_INFORMATION_AVAILABLE" | translate }}</p>
          }
        } @else {
          <p class="p-3">{{ "LOADING" | translate }}...</p>
        }
      </div>
    </div>
  </div>
</div>
}
